/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFZoomyAccountDomainConfidenceMap } from './CRSFZoomyAccountDomainConfidenceMap';
import {
    CRSFZoomyAccountDomainConfidenceMapFromJSON,
    CRSFZoomyAccountDomainConfidenceMapFromJSONTyped,
    CRSFZoomyAccountDomainConfidenceMapToJSON,
} from './CRSFZoomyAccountDomainConfidenceMap';

/**
 * Model that holds all domain confidence scores gathered for each account and automation domains.
 * @export
 * @interface CRSFZoomyDomainConfidenceMapList
 */
export interface CRSFZoomyDomainConfidenceMapList {
    /**
     * 
     * @type {Array<CRSFZoomyAccountDomainConfidenceMap>}
     * @memberof CRSFZoomyDomainConfidenceMapList
     */
    confidence_map_list: Array<CRSFZoomyAccountDomainConfidenceMap>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CRSFZoomyDomainConfidenceMapList
     */
    confidence_thresholds: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CRSFZoomyDomainConfidenceMapList
     */
    version: string;
}

/**
 * Check if a given object implements the CRSFZoomyDomainConfidenceMapList interface.
 */
export function instanceOfCRSFZoomyDomainConfidenceMapList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confidence_map_list" in value;
    isInstance = isInstance && "confidence_thresholds" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function CRSFZoomyDomainConfidenceMapListFromJSON(json: any): CRSFZoomyDomainConfidenceMapList {
    return CRSFZoomyDomainConfidenceMapListFromJSONTyped(json, false);
}

export function CRSFZoomyDomainConfidenceMapListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFZoomyDomainConfidenceMapList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confidence_map_list': ((json['confidence_map_list'] as Array<any>).map(CRSFZoomyAccountDomainConfidenceMapFromJSON)),
        'confidence_thresholds': json['confidence_thresholds'],
        'version': json['version'],
    };
}

export function CRSFZoomyDomainConfidenceMapListToJSON(value?: CRSFZoomyDomainConfidenceMapList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confidence_map_list': ((value.confidence_map_list as Array<any>).map(CRSFZoomyAccountDomainConfidenceMapToJSON)),
        'confidence_thresholds': value.confidence_thresholds,
        'version': value.version,
    };
}

